// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export class PammBase {
    public static FUND_TYPE_CLOSE = 0;
    public static FUND_TYPE_OPEN = 1;
}
